import { createContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [memberAuth, setMemberAuth] = useState({});

  return (
    <AuthContext.Provider value={{ auth, setAuth, memberAuth, setMemberAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
